// src/Pages/LandingPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sessionManager } from "../../Config/cookies";
import logo from "../../Assets/images/logo.jpg";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";

const LandingPage = () => {
  const [animationData, setAnimationData] = useState(null);
  const navigate = useNavigate();

  // 🔥 التوجيه التلقائي إذا كان المستخدم مسجّل دخول
  useEffect(() => {
    if (sessionManager.hasSession()) {
      navigate("/home"); // انتقال مباشر للصفحة الرئيسية
    }
  }, [navigate]);

  // جلب الأنيميشن من public
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/Animation.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("خطأ في تحميل الأنيميشن:", err));
  }, []);

  return (
    <div dir="rtl" className="font-cairo bg-light min-h-screen text-dark">
      {/* Navbar */}
      <nav className="flex justify-between items-center px-6 md:px-16 py-4 shadow-md bg-light">
        <div className="flex items-center gap-3">
          <img src={logo} alt="شعار الموقع" className="w-12 h-12 rounded-full" />
          <span className="text-2xl md:text-3xl font-bold text-main1">
            نمبر ون
          </span>
        </div>

        <div className="flex gap-3">
          <Link to="/login">
            <button className="px-4 py-2 rounded-xl border border-main1 text-main1 hover:bg-opacity-90 transition font-cairo">
              تسجيل الدخول
            </button>
          </Link>
          <Link to="/register">
            <button className="px-4 py-2 rounded-xl bg-main1 text-light transition font-cairo hover:bg-opacity-90">
              تسجيل
            </button>
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <main className="flex flex-col-reverse md:flex-row items-center justify-between px-6 md:px-20 py-16 gap-12 md:gap-20">
        {/* Text */}
        <div className="md:w-1/2 text-right animate-fadeUpSmooth">
          <h1 className="text-4xl md:text-5xl font-extrabold leading-snug mb-6 text-main1">
            أهلا بك في لوحة التحكم الخاصة بك
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-6">
            "نمبر ون" يوفر لك منصة آمنة وسريعة لتحويل الأموال ومتابعة جميع عملياتك المالية في مكان واحد.
          </p>
          <div className="flex gap-4 justify-start">
            <Link to="/register">
              <button className="px-6 py-3 bg-main1 text-light rounded-xl transition font-cairo text-lg shadow-md hover:bg-opacity-90">
                ابدأ الآن
              </button>
            </Link>
          </div>
        </div>

        {/* Animation */}
        <div className="md:w-1/2 flex justify-center animate-fadeSlideUp">
          {animationData ? (
            <Lottie animationData={animationData} loop={true} className="max-w-md w-full" />
          ) : (
            <p>جارٍ تحميل الرسوم...</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default LandingPage;




